import { render } from "./Pubut.vue?vue&type=template&id=01c84e0b"
import script from "./Pubut.vue?vue&type=script&lang=js"
export * from "./Pubut.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__